export const SORRY_NO_RESULT_FOUND="Sorry! No Result Found"
export const THREE_DASH = "---"
export const NA = "NA"
export const SOMETHING_WENT_WRONG = "Something went wrong."
export const NO_DATA_FOUND_PLEASE_TRY_AGAIN ="No data found, Please try again!"
export const TRY_SEARCHING_WITH_ANOTHER_KEYWORD ="Try searching with another keyword!"
export const DASHBOARD="Dashboard"
export const PRODUCTS_LABEL="Products"
export const ENQUIRY_LABEL ="Inquiry"
export const INQUIRY_TITLE = "Inquiry | Omphalos Technology";
export const SERVICE_TITLE = "Services | Omphalos Technology";
export const ADD_SERVICE_TITLE = "Add Service | Omphalos Technology"
export const SERVICES_LABEL="Services"
export const COPY_SI="© SHIVINFOTECH."
export const DESIGNED_BY_SI ="Design & Develop by Shivinfotech"
export const EMAIL_IS_REQUIRED ="Email is required.";
export const EMAIL_LABEL = "Email";
export const EMPTY_STRING = ''
export const LOGIN_TITLE = "LogIn | Omphalos Technology";
export const PASSWORD_IS_REQUIRED = "Password is required."
export const PASSWORD_LABEL = "Password";
export const PLACEHOLDER_EMAIL = "Enter email";
export const PLACEHOLDER_PASSWORD = "Enter password";
export const PLEASE_ENTER_VALID_EMAIL_ADDRESS = "Please enter valid email address."
export const SIGNIN = "Sign In";
export const WELCOME_BACK =  "Welcome Back !"
export const CRAFTED_BY_SHIVINFOTECH ="Shiv Infotech"
export const FORGOT_PASS_QUE="Forgot Password?"
export const VERIFY_EMAIL = "Verify Email"
export const WAIT_I_REMEMBER = "Wait, I remember my password... "
export const CHANGE_PASS_FUNC="Change Password"
export const LOGOUT_FUNC="Logout"
export const ADMIN_HEAD="Admin"
export const FORGOT_PASSWORD_TITLE = "Verify Email | Omphalos Technology";
export const SEND_RESET_LINK="Send Reset Link"
export const SEND_OTP = "Send OTP"
export const ENTER_YOUR_EMAIL_AND_INSTRUCTIONS_WILL_BE_SENT  = "Enter your email and OTP will be sent to you!"; 
export const BACK_TO_LOGIN="Back to Login"
export const CLICK_HERE = "Click here"
export const CONFIRM_PASSWORD_LABEL = "Confirm Password";
export const CURRENT_PASSWORD_LABEL = "Current Password";
export const CHANGE_PASSWORD="Change Password"
export const CHANGE_PASSWORD_TITLE="Change Password | Omphalos Technology"
export const PRODUCTS_TITLE="Products | Omphalos Technology"
export const ADD_PRODUCT = "Add Product"
export const PRODUCT = "Product"
export const SERVICES = "Services"
export const TYPE_LABEL = "Type"
export const DETAILS_LABEL = "Details"
export const EXPERTISE="Expertise"
export const AREA_LABEL="Area"
export const METHODOLOGY = "Methodology"
export const STEPS_LABEL="Steps"
export const CONTACT_LABEL ="Contact"
export const CONTACT_DETAILS_LABEL ="Contact Details"
export const BENIFITS = "Benefits"
export const DESCRIPTION_LABEL = "Description"
export const ADD_PRODUCT_TITLE = "Add Product | Omphalos Technology"
export const PRODUCT_NAME_LABEL ="Product Name"
export const PRODUCT_DESCRIPTION_LABEL ="Product Description"
export const PRODUCT_IMAGE_LABEL = "Product Image"
export const OVERVIEW_IMG= "Overview image"
export const SERVICE_IMG="Service image"
export const RS1_IMG="Right sidebar image 1"
export const RS2_IMG="Right sidebar image 2"
export const ONE = "1"
export const TWO = "2"
export const THREE = "3"
export const FOUR = "4"
export const UPDATE_PASSWORD_TITLE = "Update Password | Omphalos Technology";
export const PLEASE_ENTER_YOUR_DETAILS_TO_UPDATE_PASS = "Please enter your details to update your password."
export const PASSWORDS_MUST_MATCH = " Password and confirm password should be same.";
export const OTP_LABEL = "OTP";
export const NEW_PASSWORD_LABEL = "Password";
export const UPDATE_PASSWORD="Update Password"
export const OTP_MUST_BE_A_NUMBER = "OTP must be a number"
export const FIRST_NAME_HEADER="First Name"
export const LAST_NAME_HEADER="Last Name"
export const EMAIL_HEADER="Email"
export const PHONE_NUMBER_HEADER="Phone Number"
export const STATUS_HEADER="Status"
export const RESOLVE = "resolve"
export const RESOLVED="resolved" 
export const PENDING = "pending"
export const ACTION_HEADER = "Action"
export const RESOLVED_LABEL="Resolved"
export const BUTTON_LABEL="button"
export const DISABLED_LABEL="disabled"
export const POINTER_LABEL="pointer"
export const PENDING_LABEL="Pending"
export const INQUIRIES_LABEL="Inquiry"
export const STATUS_LABEL="Status"
export const UPDATE_LABEL="Update"
export const UPDATING_LABEL ="Updating"
export const SUBMITTING_LABEL ="Submitting"
export const SUBMIT_LABEL="Submit"
export const CANCEL_LABEL="Cancel"
export const SEARCH_INQUIRIES = "Search"
export const IMAGE_ONE_MB_TOAST="File size should not exceed 1 MB."
export const ONLY_IMAGES_ALLOWED_TOAST = "Only image files (JPEG, PNG) are allowed."
export const SEARCH_PRODUCTS = "Search"
export const SERIAL_NO="Sr.No."
export const ARE_YOU_SURE_DELETE="Are you sure you want to delete this record?"
export const DELETE_LABEL = "Delete"
export const EDIT_CAPI="EDIT"
export const DELETE_CAPI="DELETE"
export const ID_ACCESSOR = "id"
export const PRODNAME_ACCESSOR="product_name"
export const ACTIONS_ACCESSOR="actions"
export const ADD_LABEL="Add"
export const EDIT_PRODUCT="Edit Product"
export const BACK="Back"
export const ADD_SERVICE = "Add Service"
export const EDIT_SERVICE="Edit Service"
export const SUB_SERVICE_LABEL="Sub-Service"
export const SERVICENAME_ACCESSOR="service_name"
export const SERVICE_DESC="Service Description"
export const SERVICENAME_HEADER = "Service Name"
export const TITLE_HEADER = "Title"
export const SERVICE_APPROACH = "Service Approach"
export const SERVICE_ATC = "Service ATC"
export const SERVICE_BENEFITS = "Service Benefits"
export const SERVICE_CONSULTING = "Service Consulting"
export const CONSULTING = "Consulting"
export const ATC = "ATC"
export const APPROACH = "Approach"
export const MEMBERS = "Members"
export const MEMBERS_TITLE="Members | Omphalos Technology"
export const ADD_MEMBER = "Add Member"
export const EDIT_MEMBER = "Edit Member"
export const MEMBER_NAME = "Member Name"
export const MEMBER_POSITION = "Member Position"
export const MEMBER_IMAGE = "Member Image"
export const OMPHALOS_LABEL = "Omphalos"